import request from "components/Utils/Request";
export const CLIENT_PAYMENT_LIST_REQUEST = "CLIENT_PAYMENT_LIST_REQUEST";
export const CLIENT_PAYMENT_LIST_SUCCESS = "CLIENT_PAYMENT_LIST_SUCCESS";
export const CLIENT_PAYMENT_LIST_FAILURE = "CLIENT_PAYMENT_LIST_FAILURE";
export const ADD_CLIENT_PAYMENT_REQUEST = 'ADD_CLIENT_PAYMENT_REQUEST';
export const ADD_CLIENT_PAYMENT_SUCCESS = 'ADD_CLIENT_PAYMENT_SUCCESS';
export const ADD_CLIENT_PAYMENT_FAILURE = 'ADD_CLIENT_PAYMENT_FAILURE';
export const PAYMENT_DETAIL_LIST_REQUEST = "PAYMENT_DETAIL_LIST_REQUEST";
export const PAYMENT_DETAIL_LIST_SUCCESS = "PAYMENT_DETAIL_LIST_SUCCESS";
export const PAYMENT_DETAIL_LIST_FAILURE = "PAYMENT_DETAIL_LIST_FAILURE";
export const UPDATE_CLIENT_PAYMENT_REQUEST = 'UPDATE_CLIENT_PAYMENT_REQUEST';
export const UPDATE_CLIENT_PAYMENT_SUCCESS = 'UPDATE_CLIENT_PAYMENT_SUCCESS';
export const UPDATE_CLIENT_PAYMENT_FAILURE = 'UPDATE_CLIENT_PAYMENT_FAILURE';
export const DELETE_CLIENT_PAYMENT_REQUEST = 'DELETE_CLIENT_PAYMENT_REQUEST';
export const DELETE_CLIENT_PAYMENT_SUCCESS = 'DELETE_CLIENT_PAYMENT_SUCCESS';
export const DELETE_CLIENT_PAYMENT_FAILURE = 'DELETE_CLIENT_PAYMENT_FAILURE';

const { REACT_APP_API_URL } = process.env;

export const clientPaymentListRequest = () => ({
    type: CLIENT_PAYMENT_LIST_REQUEST
});
export const clientPaymentListSuccess = (payload) => ({
    type: CLIENT_PAYMENT_LIST_SUCCESS,
    payload
});
export const clientPaymentListFailure = (payload) => ({
    type: CLIENT_PAYMENT_LIST_FAILURE,
    payload
})

export const AddClientPaymentRequest = () => ({
  type: ADD_CLIENT_PAYMENT_REQUEST
});
export const AddClientPaymentSuccess = payload => ({
  type: ADD_CLIENT_PAYMENT_SUCCESS,
  payload
});
export const AddClientPaymentFailure = payload => ({
  type: ADD_CLIENT_PAYMENT_FAILURE,
  payload
});

export const PaymentDetailListRequest = () => ({
  type: PAYMENT_DETAIL_LIST_REQUEST
});
export const PaymentDetailListSuccess = (payload) => ({
  type: PAYMENT_DETAIL_LIST_SUCCESS,
  payload
});
export const PaymentDetailListFailure = (payload) => ({
  type: PAYMENT_DETAIL_LIST_FAILURE,
  payload
})

export const UpdateClientPaymentRequest = () => ({
  type: UPDATE_CLIENT_PAYMENT_REQUEST
});
export const UpdateClientPaymentSuccess = payload => ({
  type: UPDATE_CLIENT_PAYMENT_SUCCESS,
  payload
});
export const UpdateClientPaymentFailure = payload => ({
  type: UPDATE_CLIENT_PAYMENT_FAILURE,
  payload
});

export const DeleteClientPaymentRequest = () => ({
  type: DELETE_CLIENT_PAYMENT_REQUEST
});
export const DeleteClientPaymentSuccess = payload => ({
  type: DELETE_CLIENT_PAYMENT_SUCCESS,
  payload
});
export const DeleteClientPaymentFailure = payload => ({
  type: DELETE_CLIENT_PAYMENT_FAILURE,
  payload
});

export const paymentDetailAction = payload => {
    return {
      type: 'PAYMENTDETAIL',
      payload
    };
  };
  
export const paymentDataAction = payload => {
  return {
    type: 'PAYMENTDATA',
    payload
  };
};

  export const paymentDetailsErrorAction = payload => {
    return {
      type: 'PAYMENTDETAILSERROR',
      payload
    };
  };

  export const paymentDeletedSuccessAction = payload => {
    return {
      type: 'DELETE_PAYMENT_SUCCESS',
      payload
    };
  };
  
  export const resetPaymentDeletedAction = payload => {
    return {
      type: 'RESET_PAYMENT_DELETED',
      payload
    };
  };

export const clientPaymentListAPI = (payload, successData, errorMSg, headers = {}) => {
    return (dispatch) => {
        dispatch(clientPaymentListRequest());
        const url = `${REACT_APP_API_URL}/client-payment-list`;
        return request("POST", url, payload,"",headers)
            .then((res) => {
                if (res?.data.status === 200) {
                    successData(res)
                    dispatch(clientPaymentListSuccess(res));
                } else {
                    errorMSg(res)
                }
            }).catch((err) => {
                errorMSg(err?.res);
                dispatch(clientPaymentListFailure("Something went wrong"));
                throw err;
            })
    }
}

export const addClientPaymentAPI = (payload, successData, errorMsg, headers = {}) => {
    return dispatch => {
      dispatch(AddClientPaymentRequest());
      return request(
        'POST',
        `${REACT_APP_API_URL + '/add-payment-detail'}`,
        payload,
        "",
        headers
      )
        .then(response => {
          if (response?.data?.status === 200) {
            successData(response);
            dispatch(AddClientPaymentSuccess(response));
          } else {
            errorMsg(response);
          }
        })
        .catch(error => {
          errorMsg(error?.response);
          dispatch(AddClientPaymentFailure('Something went wrong'));
          throw error;
        });
    };
  };

  export const paymentDetailListAPI = (payload, successData, errorMSg,headers = {}) => {
    return (dispatch) => {
        dispatch(PaymentDetailListRequest());
        const url = `${REACT_APP_API_URL}/payment-detail-list`;
        return request("POST", url, payload,"",headers)
            .then((res) => {
                if (res?.data.status === 200) {
                    successData(res)
                    dispatch(PaymentDetailListSuccess(res));
                } else {
                    errorMSg(res)
                }
            }).catch((err) => {
                errorMSg(err?.res);
                dispatch(PaymentDetailListFailure("Something went wrong"));
                throw err;
            })
    }
}

export const updateClientPaymentAPI = (payload, successData, errorMsg, headers = {}) => {
  return dispatch => {
    dispatch(UpdateClientPaymentRequest());
    return request(
      'POST',
      `${REACT_APP_API_URL + '/update-payment-detail'}`,
      payload,
      "",
      headers
    )
      .then(response => {
        if (response?.data?.status === 200) {
          successData(response);
          dispatch(UpdateClientPaymentSuccess(response));
        } else {
          errorMsg(response);
        }
      })
      .catch(error => {
        errorMsg(error?.response);
        dispatch(UpdateClientPaymentFailure('Something went wrong'));
        throw error;
      });
  };
};

export const deleteClientPaymentDetailAPI = (payload, successData, errorMsg, headers = {}) => {
  return dispatch => {
    dispatch(DeleteClientPaymentRequest());
    return request(
      'DELETE',
      `${REACT_APP_API_URL + '/delete-payment-detail'}`,
      payload,
      "",
      headers
    )
      .then(res => {
        if (res?.data.status === 200) {
          successData(res);
          dispatch(DeleteClientPaymentSuccess(res));
        } else {
          errorMsg(res);
        }
      })
      .catch(err => {
        errorMsg(err?.res);
        dispatch(DeleteClientPaymentFailure('Something went wrong'));
        throw err;
      });
  };
};